import PressButton from './PressButton';

class ToggleButton extends PressButton {
	constructor(obj) {
		super(obj);
		this.active = false;
		this.obj = obj;
	}

	clickHandler(e) {
		window.sm.play({ name: 'press_click_sfx' });
		this.active = !this.active;
		super.clickHandler(e);
		// if (this.obj.press) {
		//   if (this.active) {
		//     super.pressDown()
		//   } else {
		//     super.pressUp()
		//   }
		// } else {
		if (this.active) {
			super.mouseDownHandler(e);
		} else {
			super.mouseUpHandler(e);
		}
		// }
	}
	mouseupoutsideHandler(e) {
		if (this.active) {
			super.mouseDownHandler(e);
		} else {
			super.mouseUpHandler(e);
		}
	}
	setActive(active) {
		// if (this.obj.press) {
		//   if (this.active) {
		//     super.pressDown()
		//   } else {
		//     super.pressUp()
		//   }
		// } else {
		this.active = active;
		if (active) {
			super.mouseDownHandler();
		} else {
			super.mouseUpHandler();
		}
		// }
	}

	getSize() {
		return {
			width: this.bg.width,
			height: this.bg.height
		};
	}
}

export default ToggleButton;
